var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as App from '../../app';
import * as SDK from '../../lib/sdk';
import bridge from '@vkontakte/vk-bridge';
import { getDayNumber } from '../../lib/utils/datetime/getDayNumber';
export function syncAll(game, cb) {
    var _this = this;
    if (FOR_VK) {
        bridge
            .send('VKWebAppStorageGet', { keys: ['maxScore', 'dailyBonus', 'learned'] })
            .then(function (data) {
            if (data && data.keys) {
                var maxScoreItem = data.keys.find(function (_a) {
                    var key = _a.key;
                    return key === 'maxScore';
                });
                if (maxScoreItem) {
                    var maxScore = Number(maxScoreItem.value);
                    if (!isNaN(maxScore) && game.getMaxCounter() < maxScore) {
                        if (App.storage.get().maxScore < maxScore) {
                            App.storage.upd({ maxScore: maxScore });
                        }
                        game.setMaxCounter(maxScore);
                    }
                }
                var dailyBonusItem = data.keys.find(function (_a) {
                    var key = _a.key;
                    return key === 'dailyBonus';
                });
                if (dailyBonusItem && /^\[.*\]$/.test(dailyBonusItem.value)) {
                    var currentDay = getDayNumber(new Date());
                    var _a = JSON.parse(dailyBonusItem.value), history_1 = _a[0], receivedDay = _a[1];
                    var receivedDayLocal = App.storage.get().dailyBonusReceivedDay;
                    if (receivedDay > receivedDayLocal && receivedDay <= currentDay && checkDailyBonusHistory(history_1)) {
                        App.storage.upd({ dailyBonusHistory: history_1, dailyBonusReceivedDay: receivedDay });
                    }
                }
                var learnedItem = data.keys.find(function (_a) {
                    var key = _a.key;
                    return key === 'learned';
                });
                if (learnedItem && learnedItem.value === 'true') {
                    App.storage.upd({ learned: true });
                }
            }
            if (cb)
                cb();
        })
            .catch(function (err) { return App.stat.error(err); });
        App.Fn.initVkBanner();
    }
    if (FOR_YANDEX) {
        var _a = SDK.Data.SYNC_STRATEGY, MAX_INT = _a.MAX_INT, MIN_INT_WITHOUT_0 = _a.MIN_INT_WITHOUT_0, TRUE = _a.TRUE;
        SDK.Data.sync([
            { name: 'created', strategy: MIN_INT_WITHOUT_0 },
            { name: 'maxScore', strategy: MAX_INT },
            { name: 'purchaseTime', strategy: MAX_INT },
            { name: 'rewardedTime', strategy: MAX_INT },
            { name: 'learned', strategy: TRUE },
        ])
            .then(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (DEVELOPMENT)
                    console.log('Sync OK!');
                return [2 /*return*/];
            });
        }); })
            .catch(function (err) {
            App.stat.error(err);
        })
            .finally(function () {
            if (cb)
                cb();
        });
    }
}
function checkDailyBonusHistory(history) {
    return Array.isArray(history);
}
